const {
  onlyNumericNormalize,
  zipCodeRegexNumeric,
  SPACE
} = require('../helpers');

const states = {
  DC: 'Capital District',
  AM: 'Amazonas',
  AN: 'Antioquia',
  AR: 'Arauca',
  AT: 'Atlántico',
  BL: 'Bolívar',
  BY: 'Boyacá',
  CL: 'Caldas',
  CQ: 'Caquetá',
  CS: 'Casanare',
  CA: 'Cauca',
  CE: 'Cesar',
  CH: 'Chocó',
  CO: 'Córdoba',
  CU: 'Cundinamarca',
  GN: 'Guainía',
  GV: 'Guaviare',
  HU: 'Huila',
  LG: 'La Guajira',
  MA: 'Magdalena',
  ME: 'Meta',
  NA: 'Nariño',
  NS: 'Norte de Santander',
  PU: 'Putumayo',
  QD: 'Quindío',
  RI: 'Risaralda',
  SA: 'San Andrés y Providencia',
  ST: 'Santander',
  SU: 'Sucre',
  TO: 'Tolima',
  VC: 'Valle del Cauca',
  VP: 'Vaupés',
  VD: 'Vichada'
};

const stateOptions = [];
for (const key of Object.keys(states)) {
  stateOptions.push({ value: key, name: states[key] });
}

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 6);

exports.countryDefinition = {
  country: 'Colombia',
  code: 'CO',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town' },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'State',
      width: 0.5
    },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city', SPACE, 'stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['zipCode', 'stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(6)),
      error: 'Must be 6 numbers, 110221'
    }
  ]
};
